<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "ApprovalForecastIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
